module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Bold-6490694b37b0ee09bd915e7c439015c5.eot";